import React from 'react';

import { Search } from '@mui/icons-material';
import { InputAdornment, TextField } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

interface SearchFieldProps {
  searchTerm: string | number | null;
  handleSearch: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleClearSearch: () => void;
  handleApplySearch: (searchTerm: string) => void;
  label?: string;
  size?: 'small' | 'medium';
  fullWidth?: boolean;
  width?: string;
}

export const SearchField: React.FC<SearchFieldProps> = ({
  label,
  searchTerm,
  handleSearch,
  handleApplySearch,
  handleClearSearch,
  size, fullWidth, width
}) => {
  return (
    <TextField
      placeholder={label || 'Search'}
      variant="outlined"
      value={searchTerm}
      onChange={handleSearch}
      sx={{ width: { xs: '100%', md: fullWidth ? '100%' : width ? width : '380px' } }}
      size={size || "small"}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search
              sx={{ fontSize: '20px', cursor: 'pointer' }}
            />
          </InputAdornment>
        ),
        endAdornment: (
          <InputAdornment position="end">
            {searchTerm && (
              <ClearIcon
                sx={{ fontSize: '20px', cursor: 'pointer' }}
                onClick={handleClearSearch}
              />
            )}
          </InputAdornment>
        ),
      }}
      onKeyPress={(event) => {
        if (event.key === 'Enter') {
          handleApplySearch(searchTerm?.toString() || '');
        }
      }}
    />
  );
};
